import React from 'react';
import classNames from 'classnames';
import Field from '../../Field';

/**
 * Enhanced slogan component that displays the main slogan text along with platform stats
 * in a well-designed, responsive layout suitable for the footer
 * 
 * @param {Object} props
 * @param {Object} props.sloganData - The original slogan field data
 * @param {string} props.className - CSS class for styling
 * @param {number} props.artistCount - Number of artists on the platform
 * @param {number} props.itemCount - Number of items on the platform
 * @param {boolean} props.showCTA - Whether to show the CTA button (when not on homepage)
 */
const EnhancedSlogan = ({ 
  sloganData, 
  className = '', 
  artistCount = 40,
  itemCount = 700,
  showCTA = false
}) => {
  // Check if we're on the homepage
  const isHomepage = typeof window !== 'undefined' && (window.location.pathname === '/' || window.location.pathname === '');
  const shouldShowCTA = showCTA && !isHomepage;
  return (
    <div className={classNames("font-['Be_Vietnam_Pro']", className)}>
      {/* Main slogan text */}
      <div className="mb-4">
        <Field data={sloganData} />
      </div>
      
      {/* Platform stats - stacked layout */}
      <div className="flex items-start justify-start text-sm">
        <div className="text-center border-r-1 border-gray-300 py-2 pr-6">
          <div className="text-[#d28a60] font-bold text-lg leading-tight">
            {artistCount}+
          </div>
          <div className="text-gray-600 font-medium text-sm">
            artists
          </div>
        </div>
        
        <div className="text-center py-2 pl-6">
          <div className="text-[#d28a60] font-bold text-lg leading-tight">
            {itemCount}+
          </div>
          <div className="text-gray-600 font-medium text-sm">
            items
          </div>
        </div>
      </div>
      
      {/* CTA Button - only show when not on homepage */}
      {shouldShowCTA && (
        <div className="mt-4">
          <a
            href="/"
            className="inline-flex items-center px-4 py-2 bg-[#d28a60] hover:bg-[#c17a50] text-white font-semibold text-sm rounded-md transition-colors duration-200 no-underline"
          >
            Browse All  →
          </a>
        </div>
      )}
    </div>
  );
};

export default EnhancedSlogan;
